import { useCallback } from 'react';
import Smartlook from 'smartlook-client';
import ValidationError from 'utils/ValidationError';

const useSmartlook = () => {
  const error = useCallback((whatFailed: string, e: unknown) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!(window as any)?.smartlook) {
      return;
    }
    let strError = whatFailed;
    if (e instanceof ValidationError) {
      strError = `${strError}: ValidationError: ${JSON.stringify(
        e.fieldErrors,
      )}`;
    } else if (e instanceof Error) {
      strError = `${strError}: Error: ${e.message}`;
    } else if (typeof e === 'string') {
      strError = `${strError}: ${e}`;
    }
    Smartlook.error(strError);
  }, []);

  const identify = (clientNumber?: string) => {
    if (clientNumber) {
      Smartlook.identify(clientNumber, {});
    }
  };
  return {
    identify,
    error,
  };
};

export default useSmartlook;
